import { convertSizeUnit } from "./utils";

const extractPropFromSelectedOption = (infoObj, prop) => {
  const options = infoObj.options;
  const selected = infoObj.selected;

  return options[selected][prop];
}

export async function hash(target){
  var buffer = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(target));
  var chars = Array.prototype.map.call(new Uint8Array(buffer), ch => String.fromCharCode(ch)).join('');
  return btoa(chars);
};


export const roundPrice = (price) => Math.ceil(price).toFixed(2); // parseFloat(parseFloat(price.toFixed(2)).toFixed(1)).toFixed(2);
export const getPriceFormatted = (price) => {
  return currencySymbol?.trim()?.length > 0 ? `${currencySymbol}${roundPrice(price * currencyConversionRate)}` : Intl.NumberFormat("en-IN", {
    "currency": currency,
    "style": "currency",
    "maximumFractionDigits": 0
  }).format(price)
}

export const getCurrencySymbol = () => {
  const { currencySymbol } = productInfo;

  return currencySymbol
}
export const removeHiphen = (str) => str.replaceAll('-', '')

export const getCustomChargeItems = (styleCustomizations) => {
  const customizationItems = [];

  if (styleCustomizations != undefined && Object.keys(styleCustomizations).length > 0) {
    Object.values(styleCustomizations).forEach(styleCustomization => {
      const { selected, options } = styleCustomization;
      const chargeVariant = options[selected]?.chargeVariant;
      if (!chargeVariant) return;

      const isOneTimeChargePerItem = options[selected]?.oneTimeChargePerItem ?? false
      const item = customizationItems.find(item => item.id == chargeVariant.id)

      if (isOneTimeChargePerItem && item) return;

      customizationItems.push(chargeVariant)
    })
  }

  return customizationItems;
}

export function titleCase(str) {
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(' ');
}

const getMeasurementValueStringify = (cmValue, inValue) => {
  return `${cmValue} cm / ${inValue} in`;
}

const getAdditionalInfos = (color, productInfo) => {
  const properties = {};

  const pantoneCode = extractPropFromSelectedOption(color, 'pantoneCode');
  if (pantoneCode != undefined && pantoneCode.trim().length > 0) {
    properties['_additional_infos'] = [
      {
        "name": "Pantone Code",
        "value": pantoneCode,
        "type": "text"
      }
    ]
  }

  if (properties['_additional_infos'] == undefined) properties['_additional_infos'] = [];

  const selectedColor = color.selected;
  const selectedOption = color.options[selectedColor];

  properties['_additional_infos'].push({
    "name": "Color Swatch",
    "value": selectedOption['swatchImages']['src'],
    "type": "image_url"
  })

  if (productInfo != undefined && productInfo["fabricSpec"] != undefined) {
    properties['_additional_infos'].push({
      "name": "Fabric",
      "value": productInfo['fabricSpec'],
      "type": "text"
    })
  }

  return properties;
}

const getMeasurementOptionProps = (measurementOptionsInfo, sendRefData, fitGroupId, REFERENCE_NOUN) => {
  const selectedOption = measurementOptionsInfo.selected;
  const measurementOptions = measurementOptionsInfo.options;

  const selectedMeasurementOption = measurementOptions[selectedOption]

  const sendRefOptions = sendRefData.radio.options;

  const properties = {
    "Measurement Mode": selectedMeasurementOption.label?.replaceAll('REFNOUN', REFERENCE_NOUN),
    "_measurement_option_id": selectedOption,
    "_measurement_option": selectedMeasurementOption.label?.replaceAll('REFNOUN', REFERENCE_NOUN),
    "_customer_message": selectedMeasurementOption.customerMessage?.replaceAll('REFNOUN', REFERENCE_NOUN),
    "_measurement_mode_message": selectedMeasurementOption?.subHeading?.replaceAll('REFNOUN', REFERENCE_NOUN),
    "_measurement_options": [
      ...Object.values(measurementOptions)?.map(option => ({
        "id": option.id,
        "measurement_option": option.label,
        "customer_message": option.customerMessage
      })),
      // ...Object.values(sendRefOptions)?.map(option => ({
      //   "id": option.id,
      //   "measurement_option": option.heading.replaceAll('REFNOUN', REFERENCE_NOUN),
      //   "customer_message": option.message.replaceAll('REFNOUN', REFERENCE_NOUN)
      // }))
    ],
    "_internal_info": [
      {
        "name": "Product Fit Group Id",
        "value": fitGroupId.product
      },
      {
        "name": "Measurement Fit Group Id",
        "value": fitGroupId[selectedMeasurementOption.measurementFitGroupId]
      }
    ]
  }

  return properties;
}

const getStyleCustomizationProps = (styleCustomizations) => {
  const properties = {
    "_is_customized": false,
    "_customized_styles": []
  };

  if (styleCustomizations != undefined && Object.keys(styleCustomizations).length > 0) {
    Object.values(styleCustomizations).forEach(styleCustomization => {
      const { label, selected, isCustomized = false, options } = styleCustomization;
      properties[label] = options[selected].label;
      if (isCustomized) {
        properties._is_customized = true;
        properties._customized_styles.push(label);
      }
    })
  }

  return properties;
}

const getDefaultProperties = ({
  color,
  fit,
  sendRefData,
  measurementOptionsInfo,
  styleCustomizations,
  productInfo,
  fitGroupId,
  PRODUCT_REFERENCE_NOUN
}) => {
  
  return {
    "Color": extractPropFromSelectedOption(color, 'label'),
    "Fit": extractPropFromSelectedOption(fit, 'label'),
    ...getMeasurementOptionProps(measurementOptionsInfo, sendRefData, fitGroupId, PRODUCT_REFERENCE_NOUN),
    ...getStyleCustomizationProps(styleCustomizations),
    ...getAdditionalInfos(color, productInfo)
  };
}

const getGradedSpecByFit = (gradedSpecMF, fitSelected) => {
  return gradedSpecMF['fit'].find(fitObj => handleize(fitObj['name']) === fitSelected);
}

const getBaseSizeForStandardSizeOption = (standardSizeData) => {
  const {
    measurements: {
      anchorGraded
    }
  } = standardSizeData;

  return Object.values(anchorGraded)[0]['selected'];
}

const getStandardSizeMeasurements = (fitSelected, standardSizeData, gradedSpecMF, measurementsEnabled) => {
  const {
    measurementsToAvoid,
    measurements: {
      nonAnchorGraded,
      nonAnchorUngraded
    }
  } = standardSizeData;

  const measurementsToAvoidHandleized = measurementsToAvoid.map(measurement => handleize(measurement));
  const measurementsNeeded = measurementsEnabled.filter(x => !measurementsToAvoidHandleized.includes(x));
  const baseSizeHandleized = handleize(getBaseSizeForStandardSizeOption(standardSizeData));

  const baseUnitHandleized = handleize(gradedSpecMF['unit'] || "")
  const gradedSpec = getGradedSpecByFit(gradedSpecMF, fitSelected)?.['size']?.[baseSizeHandleized]

  const measurements = [];

  gradedSpec?.forEach(measurementObj => {
    const { label, value, enabled } = measurementObj;
    const labelHandleized = handleize(label);
    let measurementValue;

    if (!measurementsNeeded.includes(labelHandleized) || !enabled) return;
    if (nonAnchorGraded[labelHandleized] != undefined) {
      measurementValue = parseFloat(`${nonAnchorGraded[labelHandleized]['selected']}`?.replace(/-/g, '.'))
    } else if (nonAnchorUngraded[labelHandleized] != undefined) {
      measurementValue = parseFloat(`${nonAnchorUngraded[labelHandleized]['selected']}`?.replace(/-/g, '.'))
    } else {
      measurementValue = parseFloat(`${value}`);
    }

    const cmValue = convertSizeUnit(baseUnitHandleized, "cm", measurementValue);
    const inValue = convertSizeUnit(baseUnitHandleized, 'in', measurementValue);

    measurements.push({
      "name": label,
      "value": getMeasurementValueStringify(cmValue, inValue)
    })
  })

  return measurements;
}

export const getStandardSizeProperties = ({
  color,
  fit,
  measurementOptionsInfo,
  styleCustomizations,
  sendRefData,
  standardSizeData,
  gradedSpecMF,
  measurementsEnabled,
  productInfo,
  fitGroupId,
  PRODUCT_REFERENCE_NOUN
}) => {

  const properties = getDefaultProperties({
    color,
    fit,
    sendRefData,
    measurementOptionsInfo,
    styleCustomizations,
    productInfo,
    fitGroupId,
    PRODUCT_REFERENCE_NOUN
  })

  const baseSize = getBaseSizeForStandardSizeOption(standardSizeData)
  const measurements = getStandardSizeMeasurements(fit.selected, standardSizeData, gradedSpecMF, measurementsEnabled);

  properties["Size"] = `${baseSize}`.toUpperCase();
  properties['_measurements'] = measurements;

  return properties;
}

const getBaseSizeForDIY = (anchorLabelHandleized, anchorValue, gradedSpec) => {

  let i = 0;
  const sizeLength = Object.keys(gradedSpec).length;

  for (const [baseSize, measurementsArr] of Object.entries(gradedSpec)) {
    const anchorObj = measurementsArr.find(measurement => handleize(measurement.label) === anchorLabelHandleized);
    if (anchorObj == undefined) {
      i++;
      continue;
    }

    const { startRange, endRange } = anchorObj;

    if (i === 0) {
      if (anchorValue < startRange) {
        return baseSize.toUpperCase();
      }
    } else if (i === sizeLength) {
      if (anchorValue > endRange) {
        return baseSize.toUpperCase();
      }
    }

    if (anchorValue >= startRange && anchorValue < endRange) {
      return baseSize.toUpperCase();
    }

    i++;
  }

}

const getDIYMeasurementsWithBaseSize = (diyData, gradedSpec, baseUnit, measurementsInfo) => {
  const properties = {};
  // const anchorValuesBySize = getAnchorValuesBySize(gradedSpec);
  let baseSize;

  Object.values(diyData.measurements)?.forEach(measurement => {
    const { label, value, isEnabled } = measurement;

    if (!isEnabled) return;

    const labelHandleized = handleize(label);
    const isAnchor = measurementsInfo[labelHandleized]['isAnchor'];

    if (isAnchor) {
      baseSize = getBaseSizeForDIY(labelHandleized, baseUnit == "cm" ? value.cm : value.in, gradedSpec, baseUnit);
      properties['Size'] = `${baseSize}`.toUpperCase();
    }

    const { cm: cmValue, in: inValue } = value;

    properties[label] = getMeasurementValueStringify(cmValue, inValue);
  })
  return properties;
}

export const getVariantId = (colorSelected, measureTypeOption, productInfo) => {
  const { id } = productInfo['variants'][measureTypeOption][colorSelected];
  return id;
}

export const getDIYProperties = ({
  color,
  fit,
  measurementOptionsInfo,
  styleCustomizations,
  gradedSpecMF,
  sendRefData,
  diyData,
  measurementsInfo,
  canAddMeasurements,
  productInfo,
  fitGroupId,
  PRODUCT_REFERENCE_NOUN
}) => {

  const gradedSpec = getGradedSpecByFit(gradedSpecMF, fit.selected)?.size;
  const measurementsWithBaseSize = canAddMeasurements
    ? getDIYMeasurementsWithBaseSize(diyData, gradedSpec, gradedSpecMF.unit, measurementsInfo)
    : {}


  return {
    ...getDefaultProperties({
      color,
      fit,
      sendRefData,
      measurementOptionsInfo,
      styleCustomizations,
      productInfo,
      fitGroupId,
      PRODUCT_REFERENCE_NOUN
    }),
    ...measurementsWithBaseSize
  };
}

export const getSendRefProperties = ({
  color,
  fit,
  sendRefData,
  measurementOptionsInfo,
  styleCustomizations,
  productInfo,
  fitGroupId,
  PRODUCT_REFERENCE_NOUN
}) => {

  return {
    ...getDefaultProperties({
      color,
      fit,
      sendRefData,
      measurementOptionsInfo,
      styleCustomizations,
      productInfo,
      fitGroupId,
      PRODUCT_REFERENCE_NOUN
    }),
    // ...getSendRefMeasurementOptionProps(sendRefData, measurementOptionsInfo)
  };
}

export const getVirtualConsultationProperties = ({
  color,
  fit,
  sendRefData,
  measurementOptionsInfo,
  styleCustomizations,
  productInfo,
  fitGroupId,
  PRODUCT_REFERENCE_NOUN
}) => {

  return {
    ...getDefaultProperties({
      color,
      fit,
      sendRefData,
      measurementOptionsInfo,
      styleCustomizations,
      productInfo,
      fitGroupId,
      PRODUCT_REFERENCE_NOUN
    })
  };
}

export const getMadeToMeasureProperties = ({
  color,
  fit,
  sendRefData,
  measurementOptionsInfo,
  styleCustomizations,
  productInfo,
  fitGroupId,
  PRODUCT_REFERENCE_NOUN
}) => {

  return {
    ...getDefaultProperties({
      color,
      fit,
      sendRefData,
      measurementOptionsInfo,
      styleCustomizations,
      productInfo,
      fitGroupId,
      PRODUCT_REFERENCE_NOUN
    })
  };
}